import React from "react";
import {
  Row,
  Col,
  Card,
  Table,
  Radio,
  Typography,
  Space,
  Button,
  List,
  Spin,
} from "antd";
import { LoadingOutlined } from "@ant-design/icons";

const { Text, Title } = Typography;
const antIcon = <LoadingOutlined spin />;

export default (props) => {
  const {
    ListCol,
    ListData,
    filterData,
    pagination,
    onFilter,
    filterValue,
    filters,
    Search,
    ExtraBlocks,
    BlocksCount,
    onSearch,
    onRow,
    total,
    totaltitle,
    title,
    onChange,
    listClass,
    blackCard,
    extraBtn,
    headerBtn,
    extraAction,
    btnClass,
    headclass,
    listStat,
    border,
    selectRows,
    loading = false,
    filteredRecords,
    paginationSummaryType = "detailed"
  } = props;
  const searchProps = {
    field1: props.field1,
    field2: props.field2,
    field3: props.field3,
  };

  const currentPage = pagination?.current || pagination?.defaultCurrent || 1;
  const pageSize = pagination?.pageSize || 10;
  const safeFilteredRecords = typeof filteredRecords === 'number' ? filteredRecords : 0;
  const safeTotal = typeof total === 'number' ? total : 0;

  const start = safeFilteredRecords === 0 ? 0 : (currentPage - 1) * pageSize + 1;
  const end = safeFilteredRecords === 0 ? 0 : Math.min(currentPage * pageSize, safeFilteredRecords);

  return (
    <Card className={`design-card ${listClass ? listClass : ""}`}>
      <Row gutter={[20, 30]}>
        {title && (
          <Col span={24}>
            <Title level={4} className={`mb-0 ${headclass ? headclass : ""}`}>
              {title}
            </Title>
          </Col>
        )}
        {listStat &&
          listStat.map((x, i) => (
            <Col flex={x.width} key={i}>
              <Card bordered={false} className="red-card">
                <Space size={20}>
                  {x.icon}
                  <Space size={4} direction="vertical">
                    <Text className="op-6">{x.title}</Text>
                    <Title level={4} className=" c-white mb-0">
                      {x.text}
                    </Title>
                  </Space>
                </Space>
              </Card>
            </Col>
          ))}
        {filters && (
          <Col span={24}>
            <Radio.Group
              size="large"
              className="radio-tabs"
              buttonStyle="solid"
              options={filters}
              onChange={onFilter}
              value={filterValue}
              optionType="button"
            />
          </Col>
        )}
        {ExtraBlocks && (
          <Col span={24}>
            <ExtraBlocks data={BlocksCount} />
          </Col>
        )}
        {onSearch && (
          <Col span={24}>
            <Search onSearch={onSearch} {...searchProps} />
          </Col>
        )}
        <Col span={24}>
          <Spin indicator={antIcon} size="large" spinning={loading}>
            <Table
              scroll={{ x: props.scrolling ? props.scrolling : 1000 }}
              onRow={onRow}
              className={`custom-table ${props.classes ? props.classes : ""}`}
              bordered={border}
              columns={ListCol}
              dataSource={
                filterData != null
                  ? filterData
                  : ListData?.map((value, index) => ({
                      key: index + 1,
                      ...value,
                    }))
              }
              pagination={pagination}
              rowSelection={selectRows}
              onChange={onChange}
            />
            <Col span={24}>
              <Row justify="space-between" align="middle">
                <Col>
                  <Text className="c-gray">
                    {paginationSummaryType === "simple"
                      ? `Showing ${start}-${end} of total ${safeTotal.toLocaleString()}`
                      : `Showing ${start}-${end} of ${safeFilteredRecords} (total from ${safeTotal.toLocaleString()})`}
                  </Text>
                </Col>
                <Col>
                </Col>
              </Row>
            </Col>
          </Spin>
        </Col>
        {extraBtn && (
          <Col span={24} className="text-right">
            <Button
              type="primary"
              size="large"
              htmlType="button"
              className={btnClass ? btnClass : ""}
              onClick={extraAction}
            >
              {extraBtn}
            </Button>
          </Col>
        )}
      </Row>
    </Card>
  );
};
